
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const ComoVenderPage = lazy(() => import('../pages/como-vender/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/article'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/como-vender-tu-coche',
    element: <ComoVenderPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />,
  },
  {
    path: '/preguntas-frecuentes',
    element: <FaqPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
